import { render, staticRenderFns } from "./WarningNotDeliveryNotInternet.vue?vue&type=template&id=0bd57b0d&lang=pug"
import script from "./WarningNotDeliveryNotInternet.vue?vue&type=script&lang=js"
export * from "./WarningNotDeliveryNotInternet.vue?vue&type=script&lang=js"
import style0 from "./WarningNotDeliveryNotInternet.vue?vue&type=style&index=0&id=0bd57b0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports